<template>
    <b-container class="py-3">
        <b-row>
            <b-col>
                <div class="d-flex align-items-center justify-content-between">
                    <p :class="['h4 mr-1', { 'm-0': !$slots.description }]">
                        <slot name="title" />
                    </p>
                    <AttributesDropdownCaretIcon :is-open="isOpen" v-if="caret" />
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <span>
                    <slot name="description" />
                </span>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import AttributesDropdownCaretIcon from './AttributesDropdownCaretIcon'

export default {
    name: 'AttributesDropdownItem',
    components: {
        AttributesDropdownCaretIcon,
    },
    props: {
        caret: {
            type: Boolean,
            required: false,
            default: false,
        },
        isOpen: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
}
</script>

<style lang="scss" scoped>
p {
    color: #6e6e6e;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
